var React = require('react');

function ExternalLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 9a1 1 0 1 1 2 0v4.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 1 13.5v-9A1.5 1.5 0 0 1 2.5 3H7a1 1 0 1 1 0 2H3v8h8V9zm2-4.586L7.707 9.707a1 1 0 1 1-1.414-1.414L11.586 3H10a1 1 0 1 1 0-2h5v5a1 1 0 1 1-2 0V4.414z"}));
}

ExternalLink.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = ExternalLink;

ExternalLink.default = ExternalLink;
